// extracted by mini-css-extract-plugin
export default {"container":"DropFilesHidden_container__Lkp1b","container_inner":"DropFilesHidden_container_inner__q9OyA","icon":"DropFilesHidden_icon__2UukX"};